import {AxiosInstance, AxiosResponse} from "axios";

export interface CachedPatient {
    /** The consumer key.*/
    key: string;
    /** The firstname. */
    first_name: string;
    /** The lastname. */
    last_name: string;
    /** The birthdate. */
    birth_date: string;
}

/**
 * The customer resource.
 * @author Tony Laurent <t.laurent@apodispharma.com>
 * @param {Object} client - The injected client.
 * @returns {Object} The public object.
 */
export default function (client: AxiosInstance) {
    return {
        /**
         * Get consumer cache index.
         *
         * @returns {Promise} Promise object represents the HTTP request.
         */
        async index(): Promise<CachedPatient[]> {
            return await client.get('/consumers-cache',)
                .then((response: AxiosResponse) => response.data)
                .catch(() => []);
        }
    };
}
